import { apiCall, getHeaders } from "services/api";

const path = "/v1/user/company/documents";

export const readData = (response) => {
  if (response?.info?.title === "success") return response.data;
  throw new Error(
    typeof response === "string"
      ? response
      : response?.info?.description ||
        "Unable to process company documents. Please try again.",
  );
};

export const getDocumentTypes = async () =>
  readData(await apiCall({ method: "GET", url: `${path}/types` }));
export const getChecklist = async () =>
  readData(await apiCall({ method: "GET", url: path }));
export const getDocumentHistory = async (
  typeId,
  page = 1,
  onboardingShareholderId,
) =>
  readData(
    await apiCall({
      method: "GET",
      url: `${path}/types/${typeId}/history`,
      queryParams: {
        page,
        limit: 10,
        ...(onboardingShareholderId
          ? { onboarding_shareholder_id: onboardingShareholderId }
          : {}),
      },
    }),
  );
export const getDocumentDetail = async (id) =>
  readData(await apiCall({ method: "GET", url: `${path}/${id}` }));
export const uploadDocuments = async (rows, scope = {}) => {
  const data = new FormData();
  rows.forEach(({ file }) => data.append("files", file));
  data.append(
    "manifest",
    JSON.stringify(
      rows.map(({ file, typeId }) => ({
        document_type_id: Number(typeId),
        original_filename: file.name,
        ...scope,
      })),
    ),
  );
  const headers = getHeaders();
  delete headers["Content-Type"];
  return readData(await apiCall({ method: "POST", url: path, data, headers }));
};

export const getDocumentFile = async (id, disposition = "attachment") => {
  const response = await apiCall({
    method: "GET",
    url: `${path}/${id}/file`,
    queryParams: { disposition },
    responseType: "blob",
  });
  if (!(response instanceof Blob))
    throw new Error("The document file is unavailable or access was denied.");
  return response;
};

export const getOnboarding = async () =>
  readData(await apiCall({ method: "GET", url: `${path}/onboarding` }));
export const saveContacts = async (section, contacts) =>
  readData(
    await apiCall({
      method: "PUT",
      url: `${path}/onboarding/contacts/${section}`,
      data: { contacts },
    }),
  );
export const saveShareholder = async (id, data) =>
  readData(
    await apiCall({
      method: id ? "PUT" : "POST",
      url: `${path}/onboarding/shareholders${id ? `/${id}` : ""}`,
      data,
    }),
  );
